"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboPersonal = exports.isComboOfferPersonal = void 0;
function isComboOfferPersonal(offer) {
    return offer.limitedToDriverIds?.length === 1;
}
exports.isComboOfferPersonal = isComboOfferPersonal;
function isComboPersonal(comboType) {
    return ["Personal", "PersonalMultiday"].includes(comboType ?? "");
}
exports.isComboPersonal = isComboPersonal;
//# sourceMappingURL=isComboOfferPersonal.js.map